import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "app/login/login.service";
import { LaudosTecnicosModel } from "./laudos-tecnicos.model";
import { LaudosTecnicosService } from "./laudos-tecnicos.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ClientesService } from "../clientes/clientes.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { FichasService } from "../fichas/fichas.service";
import { TiposClientesService } from "../clientes/tipos-clientes.service";
import { UnidadesService } from "../unidades/unidades.service";
import { FaturasService } from "../faturas/faturas.service";
import { TerminaisService } from "../terminais/terminais.service";

declare let swal, $: any;

@Component({
  selector: 'app-laudos-tecnicos-financeiro',
  templateUrl: './laudos-tecnicos-financeiro.component.html'
})
export class LaudosTecnicosFinanceiroComponent extends Components implements OnInit {

  formAlterarValor: FormGroup;
  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "mercadoria": "", "cliente": "", "terminal": "", "faturado": "", "id_unidade": "", "id_fatura": "", "ordem_campo": "data_inspecao", "ordem_direcao": "d" };
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  laudos: LaudosTecnicosModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  listStatusFichas = [];
  listMercadorias = [];
  listClientes = [];
  listTerminal = [];
  listUnidades = [];
  listFaturas = [];

  alterar_valor = {
    "id_laudo_tecnico": null,
    "valor": ""
  };

  listFaturado = [{
    "texto": "Sim",
    "valor": 1
  }, {
    "texto": "Não",
    "valor": 0
  }];

  faturar = {
    "id_laudo_tecnico": null,
    "data": ""
  };

  formFaturar: FormGroup;
  carregandoBotaoFaturar: boolean = false;
  carregandoBotaoAlterarValor: boolean = false;


  constructor(
    formBuilder: FormBuilder,
    private laudosService: LaudosTecnicosService,
    private fichasService: FichasService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private tiposClientesService: TiposClientesService,
    private unidadesService: UnidadesService,
    private faturasService: FaturasService,
    private terminaisService: TerminaisService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8) + '01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao[0].url == 'financeiro') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      mercadoria: [],
      cliente: [],
      terminal: [],
      faturado: [],
      id_unidade: [],
      id_fatura: []
    });

    this.formAlterarValor = formBuilder.group({
      valor: []
    });

    this.formFaturar = formBuilder.group({
      data: []
    });

    this.fichasService.getStatus()
      .subscribe(
        json => {
          this.listStatusFichas = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });


    // busca clientes por tipo
    this.tiposClientesService.get(["clientes"])
      .subscribe(
        json => {
          for (let x in json.Payload) {
            switch (json.Payload[x].id_tipo) {
              case "1":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "2":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;

              case "6":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;
              default:
                break;
            }
          }

        },
        error => {
          this.func.showErro(error.json());
        });

    this.terminaisService.get().subscribe(res => this.listTerminal = res.Payload);

    this.mercadoriasService.get(null, null, ['id', 'nome_pt'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca unidades
    this.unidadesService.get(null, null, ['id_unidade', 'nome_tratamento'])
      .subscribe(json => {
        this.listUnidades = json.Payload;
      });

    // busca faturas
    this.faturasService.get()
      .subscribe(json => {
        this.listFaturas = json.Payload;
      });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.getPage(1);
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  delete(ficha) {
    let laudos = this.laudos;
    let laudosService = this.laudosService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFicha') + ficha.id_laudo_tecnico,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        if (self.global.debug == true) {
          console.log(laudos);
        }

        let index = laudos.indexOf(ficha);
        laudos.splice(index, 1);

        laudosService.apagar(ficha.id_laudo_tecnico)
          .subscribe(res => {
            self.laudos = laudos;
          },
            err => {
              // Revert the view back to its original state
              laudos.splice(index, 0, ficha);
              self.laudos = laudos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    filtros['id_status'] = 2;

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data_descarga'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data_descarga'] = 'ge:' + this.filtroPesquisa.data_de;
      }

      if (this.filtroPesquisa.data_ate) {
        filtros['data_descarga'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if (this.filtroPesquisa.mercadoria != '') {
      filtros['id_produto'] = this.filtroPesquisa.mercadoria;
    }

    if (this.filtroPesquisa.cliente != '') {
      filtros['id_cliente'] = this.filtroPesquisa.cliente;
    }

    if (this.filtroPesquisa.terminal != '') {
      filtros['id_terminal'] = this.filtroPesquisa.terminal;
    }

    if (this.filtroPesquisa.faturado != '') {
      filtros['faturado'] = this.filtroPesquisa.faturado;
    }

    if (this.filtroPesquisa.id_unidade != '') {
      filtros['id_unidade'] = this.filtroPesquisa.id_unidade;
    }

    if (this.filtroPesquisa.id_fatura != '') {
      filtros['id_fatura'] = this.filtroPesquisa.id_fatura;
    }

    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'data_inspecao';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['produto', 'cliente', 'cliente.moeda', 'exportador', 'terminal', 'unidade', 'status', 'fatura_gerada'], filtros, null, sort)
      .subscribe(data => {
        this.laudos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.laudos);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  enviaParaCliente(id) {

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaEnviarFichaCliente'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        self.laudosService.enviarLaudoParaCliente(id)
          .subscribe(res => {
            //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
          },
            err => {
              self.func.showErro(err.json());
            });

      });

  }


  alteraStatus(id_laudo_tecnico, id_status) {

    let laudosService = this.laudosService;

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaAlterarStatus'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true,
    },
      function () {

        laudosService.setStatus(id_laudo_tecnico, id_status)
          .subscribe(res => {
            swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");

            self.getPage(self.paginaAtual);
          },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");

              self.func.showErro(error.json());
            });

      });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "mercadoria": "", "cliente": "", "terminal": "", "faturado": "", "id_unidade": "", "id_fatura": "", "ordem_campo": "data_inspecao", "ordem_direcao": "d" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  modalAlterarValor(id_laudo_tecnico, valor, cliente: any = null) {
    this.alterar_valor["id_laudo_tecnico"] = id_laudo_tecnico;
    let valorFinal = valor;
    if (valorFinal === null || valorFinal === undefined || valorFinal === '') {
      if (cliente && cliente.valor_laudostecnicos !== undefined && cliente.valor_laudostecnicos !== null && cliente.valor_laudostecnicos !== '') {
        valorFinal = cliente.valor_laudostecnicos;
      }
    }
    this.alterar_valor["valor"] = valorFinal !== null && valorFinal !== undefined ? valorFinal : '';
    $('#modalAlterarValor').modal('show');
  }

  alterarValor() {
    this.carregandoBotaoAlterarValor = true;
    this.laudosService.setValor(this.alterar_valor["id_laudo_tecnico"], this.alterar_valor["valor"])
      .subscribe(res => {
        this.carregandoBotaoAlterarValor = false;
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.statusAlterado'), "success");
        this.getPage(this.paginaAtual);
        $('#modalAlterarValor').modal('hide');
      },
        error => {
          this.carregandoBotaoAlterarValor = false;
          swal(this.func.traduzir('front.erro'), this.func.traduzir('front.statusNaoAlterado'), "error");
          this.func.showErro(error.json());
          $('#modalAlterarValor').modal('hide');
        });
  }

  limpaAlteraValor() {
    this.alterar_valor = {
      "id_laudo_tecnico": null,
      "valor": ""
    };
    $('#modalAlterarValor').modal('hide');
  }

  modalFaturar(id_laudo_tecnico) {
    this.faturar["id_laudo_tecnico"] = id_laudo_tecnico;
    this.faturar["data"] = new Date().toISOString().substr(0, 10);
    $('#modalFaturar').modal('show');
  }

  confirmarFaturar() {
    this.carregandoBotaoFaturar = true;
    this.laudosService.faturarLaudo(this.faturar["id_laudo_tecnico"], this.faturar["data"])
      .subscribe(res => {
        this.carregandoBotaoFaturar = false;
        swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
        this.getPage(this.paginaAtual);
        $('#modalFaturar').modal('hide');
      },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        });
  }

  limpaFaturar() {
    this.faturar = {
      "id_laudo_tecnico": null,
      "data": ""
    };
    $('#modalFaturar').modal('hide');
  }

}




// WEBPACK FOOTER //
// ./src/app/laudos-tecnicos/laudos-tecnicos-financeiro.component.ts